import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import * as routes from 'constants/routes';
import { withAuthState } from 'hoc/auth';

const ExperienceHeader = ({ loggedUserInfo }) => {
  const isSuperAdmin = loggedUserInfo.isSuperAdmin;

  return (
    <nav className="container-fluid navbar tab tabsticky d-none-sm">
      {/* <div className="navbar__right d-flex"> */}
      {isSuperAdmin && (
        <>
          <div className="nav__node">
            <NavLink to={routes.ADMIN_EXPERIENCES}>Adventures Listing</NavLink>
          </div>
          <div className="nav__node d-none-sm">
            <NavLink to={routes.SAMPLE_EXPERIENCES}>Sampling Adventure</NavLink>
          </div>
        </>
      )}
    </nav>
  );
};

ExperienceHeader.propTypes = {
  loggedUserInfo: PropTypes.object.isRequired,
};

export default withAuthState(ExperienceHeader);
